<template>
    <div class="sports_item_detail sports_register_detail">
      <Form :list="itemDetail.registerform" :buttonColor="buttonColor" @submit="submit" :statement="itemDetail.statement" :userinfo="userInfo"/>
      <!-- <div class="sese">请参照示范视频角度及动作，正面/侧面拍摄动作，保证动作标准性，以便系统识别计分，谢谢</div> -->
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index.vue'

    import {Empty, Panel, Cell, Button, CellGroup} from 'vant';
    import "./index.less"
    export default {
        computed: {
            buttonColor() {
                let detail = this.detail;
                if (!detail) return '#ccc';
                return `${detail.tabstyle[0]['color']}`;
            }
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            Footbar,
            Form
        },
        data() {
            return {
                detail: '',
                itemDetail: "",
                joinList: [],
                item_sub_id: '',
                sports_id: '',
                userInfo: {}
            }
        },
        methods: {
            submit: function (e) {
                this.$dialog.confirm({
                    title: "提示",
                    confirmButtonText: '确定提交',
                    message: '信息提交后不可修改,确定提交?',
                    showCancelButton: true
                }).then(() => {

                    this.$api.mwap.submitCompare({cpgid: this.item_sub_id, registerInfo: e}).then((res) => {
                        if (+res.status === 200) {
                          this.$router.replace({ name: 'sportsResult', params:this.$route.params})
                        }
                    })

                    // on confirm
                }).catch(() => {
                    // on cancel
                });


                console.log(e)
            },
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
                let params = {cpgid: this.item_sub_id}
                Promise.all([this.$api.sports.sportsMain({sports_id:this.sports_id}), this.$api.mwap.getComparegame(params)]).then((res) => {
                    let {bgstyle, id, tabstyle, introstyle, title} = res[0].data;
                    try {
                        bgstyle = JSON.parse(bgstyle)
                        tabstyle = JSON.parse(tabstyle)
                        introstyle = JSON.parse(introstyle)
                    } catch (e) {
                        console.error(e)
                    }
                    this.detail = {id, bgstyle, tabstyle, introstyle, title}
                    this.joinList = res[1]['list'];
                    delete res[1]['data']['list']
                    if (res[1]['data']['registerform']) {
                        try {
                            res[1]['data']['registerform'] = JSON.parse(res[1]['data']['registerform']);
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    this.itemDetail = res[1]['data']
                    this.$toast.clear();
                })


            }
        },
        mounted() {
            this.item_sub_id = this.$route.params.item_sub_id
            this.sports_id = this.$route.params.sports_id
            this.$api.user.getUserInfo().then((res) => {
                if (res.status * 1 === 200) {
                    this.userInfo = res.data;
                    this.init();
                }
            });
        }

    }
</script>
